.trigger {
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  width: var(--target-min);
  height: var(--target-min);
  padding: 0;
  border: 0;
  border-radius: var(--radius-pill);
  background: transparent;
  color: var(--muted);
  cursor: pointer;
}

.trigger:hover {
  background: var(--panel-3);
  color: var(--ink);
}

.trigger[aria-expanded="true"] {
  background: var(--accent-w);
  color: var(--accent);
}

.trigger:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 1px;
}

.card {
  max-width: 340px;
}

.body {
  display: flex;
  flex-direction: column;
  gap: 6px;
  outline: none;
}

.body:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
  border-radius: var(--radius-ctl);
}

.title {
  margin: 0;
  color: var(--ink);
  font-size: var(--t-dense);
  font-weight: 650;
}

.text {
  margin: 0;
  color: var(--ink-2);
  font-size: var(--t-dense);
  line-height: 1.45;
}
